import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorage } from 'ngx-store';

@Injectable({
  providedIn: 'root'
})
export class MovementPerceptionService {
  api: string = environment.apiUrl;
  @LocalStorage('loggedUser') loggedUser: any;
  @LocalStorage('userData') userData: any;
  lan = localStorage.getItem("lan")

  constructor(private http: HttpClient) { }

  async save(body): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .post(this.api + `/movement_perception`, { answers: body }, { headers, observe: 'response' })
      .toPromise();
  }
  async check_exp(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .get(this.api + `/checkMovementPerception`, { headers, observe: 'response' }).toPromise();
  }

}
